module.exports = __webpack_public_path__ + "img/undraw_On_the_way.88820bbd.svg";